const EVENTS = {
	search_course_click: 'searchCourseClick', // user clicks on search course button (statements)
	download_app_click: 'downloadAppClick', // user clicks on download app button
	login_click: 'loginClick', // user clicks on login button
	add_prospectus_click: 'addProspectusClick', // user clicks on add prospectus button
	enquiry_form_start: 'enquiryStart', // user starts the form
	custom_enquiry: 'customEnquiry', // user writes a custom enquiry in the enquiry form
};

export type EventNameKey = keyof typeof EVENTS;

export const getEvent = (eventName: EventNameKey) => {
	return EVENTS[eventName] || null;
};
